var actionTypes = require('../../../actionTypes.js');

module.exports.createAction = (payload)=> (
            {
                type: actionTypes.mainBarComponent,
                payload: payload
            }
           )

module.exports.changeState = (previousState, payload)=> Object.assign({}, previousState, {mainBarComponent: payload})